export default "/dist/files/unknown.5506aee51e3a939a8f4cb0a3571c55e6.svg";